import { createContext, useContext, useEffect, useState } from 'react'
import { getSiteSettings } from '../services/sanity.service'

const SiteSettingsContext = createContext(null)

/**
 * Fetches site settings once from Sanity and provides them to the entire tree.
 * All child components should use useSiteSettings() instead of calling
 * getSiteSettings() directly, to avoid duplicate network requests.
 */
export function SiteSettingsProvider({ children }) {
    const [settings, setSettings] = useState(null)

    useEffect(() => {
        getSiteSettings().then(setSettings)
    }, [])

    return (
        <SiteSettingsContext.Provider value={settings}>
            {children}
        </SiteSettingsContext.Provider>
    )
}

/** Returns the site settings object, or null while loading. */
export function useSiteSettings() {
    return useContext(SiteSettingsContext)
}
